import { WebsiteStats, WebsiteStatsApi } from './types';

export const websiteStatsModel = (data?: WebsiteStatsApi): WebsiteStats => ({
  donations: data?.donations ?? '',
  totalCharityOrganisations: data?.total_charity_organisations ?? 0,
  totalCommunitiesImpacted: data?.total_communities_impacted ?? 0,
  totalUsers: data?.total_users ?? 0,
});
